import {
  useAssemblyAttachmentsGeneralNoteMutation,
  GetAssemblyDetailsDocument,
  GetAssemblyAttachmentsDocument,
} from '@/__generated__/graphql';

export function useAssemblyNoteMutation() {
  const [addAttachmentNote, { data, loading, error }] = useAssemblyAttachmentsGeneralNoteMutation();

  const updateNote = async (
    generalAttachmentsNote: string | undefined | null,
    assemblyId: string,
    structureId: string
  ) => {
    if (!assemblyId) return;
    if (!structureId) return;
    return addAttachmentNote({
      variables: {
        input: {
          generalAttachmentsNote: generalAttachmentsNote,
          assemblyId,
          structureId,
          lastModifiedFor: 'Add note to assembly attachments',
        },
      },
      refetchQueries: [GetAssemblyDetailsDocument, GetAssemblyAttachmentsDocument],
    });
  };

  return { updateNote, data, loading, error };
}
